module.exports = __webpack_public_path__ + "img/title3.49046ff9.svg";